(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo-text-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('logo-text-marquee')) {
    customElements.define('logo-text-marquee', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ltm__track');
        this.group = this.querySelector('[data-original]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.queue = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.build());
        };
        this.selectBlock = () => this.setAttribute('data-paused', '');
        this.deselectBlock = () => this.removeAttribute('data-paused');
        this.addEventListener('shopify:block:select', this.selectBlock);
        this.addEventListener('shopify:block:deselect', this.deselectBlock);
        this.motion.addEventListener('change', this.queue);
        this.observer = new ResizeObserver(this.queue);
        this.observer.observe(this.querySelector('.ltm__viewport'));
        this.observer.observe(this.group);
        document.fonts.ready.then(() => {
          if (this.isConnected) this.queue();
        });
        this.queue();
      }

      copy(node) {
        const clone = node.cloneNode(true);
        clone.removeAttribute('data-original');
        clone.setAttribute('data-copy', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        [clone, ...clone.querySelectorAll('*')].forEach(el => {
          el.removeAttribute('id');
          [...el.attributes].forEach(attribute => {
            if (attribute.name.startsWith('data-shopify-editor')) {
              el.removeAttribute(attribute.name);
            }
          });
        });
        return clone;
      }

      build() {
        this.removeAttribute('data-ready');
        this.querySelectorAll('[data-copy]').forEach(el => el.remove());
        if (this.motion.matches || !this.group.children.length) return;
        this.setAttribute('data-ready', '');
        const originals = [...this.group.children];
        const width = this.group.getBoundingClientRect().width;
        if (width <= 0) {
          this.removeAttribute('data-ready');
          return;
        }
        const repeats = Math.max(1, Math.ceil(this.clientWidth / width));
        for (let i = 1; i < repeats; i++) {
          originals.forEach(item => this.group.appendChild(this.copy(item)));
        }
        const distance = this.group.getBoundingClientRect().width;
        const speed = Math.max(1, Number(this.dataset.speed) || 45);
        this.style.setProperty('--ltm-distance', `${distance}px`);
        this.style.setProperty('--ltm-duration', `${distance / speed}s`);
        this.track.appendChild(this.copy(this.group));
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.motion?.removeEventListener('change', this.queue);
        this.removeEventListener('shopify:block:select', this.selectBlock);
        this.removeEventListener('shopify:block:deselect', this.deselectBlock);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
